<script setup lang="ts">
import { withDefaults } from 'vue'
interface PropTypes {
  value: string | number | null
}

const props = withDefaults(defineProps<PropTypes>(), {
  value: null,
})
</script>

<template>
  <template v-if="props.value !== null">
    <slot name="default" />
  </template>
  <template v-else>
    <slot name="fallback" />
  </template>
</template>
